<template>
  <b-row v-if="Object.keys(data).length" align-v="center">
    <b-col cols="12" sm="7">
      <b-row>
        <b-col>
          <div
            class="filter-tile text-center"
            :class="{ active: activeFilter === 'todayDownloads' }"
            @click="applyFilter('todayDownloads')"
          >
            <div>Stiahnuté dáta</div>
            <div class="filter-item fs-sm text-muted text-uppercase">Dnes</div>
            <hr class="my-1" />
            <div class="text-center">
              <b-badge class="bg-power align-top fs-base">
                <icon class="icon-fw" name="plug" scale="0.75" />
                {{ data.today.powerCount }}
              </b-badge>
              <b-badge class="bg-gas align-top fs-base">
                <icon class="icon-fw" name="fire" scale="0.75" />
                {{ data.today.gasCount }}
              </b-badge>
              <span class="fs-lg font-weight-bold ml-1"
                >{{ data.today.powerCount + data.today.gasCount }} /
                {{ data.subscribed }}</span
              >
            </div>
          </div>
        </b-col>
        <b-col>
          <div
            class="filter-tile text-center"
            :class="{ active: activeFilter === 'overflowsYesterday' }"
            @click="applyFilter('overflowsYesterday')"
          >
            <div>Prekročenia / Nadlimity</div>
            <div class="filter-item fs-sm text-muted text-uppercase">Včera</div>
            <hr class="my-1" />
            <div class="text-center">
              <b-badge class="bg-power align-top fs-base">
                <icon class="icon-fw" name="plug" scale="0.75" />
                {{ todayOverflows.power }}
              </b-badge>
              <b-badge class="bg-gas align-top fs-base">
                <icon class="icon-fw" name="fire" scale="0.75" />
                {{ todayOverflows.gas }}
              </b-badge>
            </div>
          </div>
        </b-col>
        <b-col>
          <div
            class="filter-tile text-center"
            :class="{ active: activeFilter === 'overflowsThisMonth' }"
            @click="applyFilter('overflowsThisMonth')"
          >
            <div>Prekročenia / Nadlimity</div>
            <div class="filter-item fs-sm text-muted text-uppercase">
              Aktuálny mesiac
            </div>
            <hr class="my-1" />
            <div class="text-center">
              <b-badge class="bg-power align-top fs-base">
                <icon class="icon-fw" name="plug" scale="0.75" />
                {{ monthOverflows.power }}
              </b-badge>
              <b-badge class="bg-gas align-top fs-base">
                <icon class="icon-fw" name="fire" scale="0.75" />
                {{ monthOverflows.gas }}
              </b-badge>
            </div>
          </div>
        </b-col>
        <b-col>
          <div
            class="filter-tile text-center"
            :class="{ active: activeFilter === 'overflowsThisYear' }"
            @click="applyFilter('overflowsThisYear')"
          >
            <div>Prekročenia / Nadlimity</div>
            <div class="filter-item fs-sm text-muted text-uppercase">
              Aktuálny rok
            </div>
            <hr class="my-1" />
            <div class="text-center">
              <b-badge class="bg-power align-top fs-base">
                <icon class="icon-fw" name="plug" scale="0.75" />
                {{ yearOverflows.power }}
              </b-badge>
              <b-badge class="bg-gas align-top fs-base">
                <icon class="icon-fw" name="fire" scale="0.75" />
                {{ yearOverflows.gas }}
              </b-badge>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" sm="5">
      <apexchart
        :height="85"
        :options="yearOverflowsChart.options"
        :series="yearOverflowsChart.series"
        type="area"
      />
    </b-col>
  </b-row>
</template>
<script>
import collect from 'collect.js'

export default {
  props: {
    defaultFilter: Object,
    filter: Object,
  },
  data() {
    return {
      data: {},
      yearOverflowsChart: {
        options: {
          chart: {
            toolbar: false,
            animations: {
              enabled: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          fill: {
            gradient: {
              opacityFrom: 0.1,
              opacityTo: 0.75,
            },
          },
          stroke: {
            width: 2,
            curve: 'smooth',
          },
          labels: [],
          xaxis: {
            type: 'datetime',
            labels: {
              show: false,
            },
            tooltip: {
              enabled: false,
            },
          },
          yaxis: {
            show: false,
            labels: {
              formatter: function (val) {
                return Math.floor(val) + 'x'
              },
            },
          },
          grid: {
            show: false,
            padding: {
              top: -20,
              right: 5,
              bottom: -10,
              left: 5,
            },
          },
        },
        series: [
          {
            name: 'Elektrina',
            color: '#EB705D',
            data: [],
          },
          {
            name: 'Plyn',
            color: '#dbb800',
            data: [],
          },
        ],
      },
      activeFilter: null,
    }
  },
  computed: {
    powerOverflows() {
      if (this.data) {
        return collect(this.data.powerOverflow)
          .map((item) => {
            let output = { ...item }
            output.overflows = item.overflows.rk + item.overflows.mrk
            return output
          })
          .groupBy('date')
          .map((item) => item.sum('overflows'))
          .all()
      }
      return {}
    },
    gasOverflows() {
      if (this.data) {
        return collect(this.data.gasOverlimit)
          .map((item) => {
            let output = { ...item }
            output.overlimit = item.overLimit105to110percent ? 1 : 0
            return output
          })
          .groupBy('date')
          .map((item) => item.sum('overlimit'))
          .all()
      }
      return {}
    },
    todayOverflows() {
      let output = {}
      output.power = this.yesterday(this.data.powerOverflow, 'YYYY-MM-DD')
      output.gas = this.yesterday(this.data.gasOverlimit, 'YYYY-MM-DD')
      return output
    },
    monthOverflows() {
      let output = {}
      output.power = this.filtered(this.data.powerOverflow, 'YYYY-MM')
      output.gas = this.filtered(this.data.gasOverlimit, 'YYYY-MM')
      return output
    },
    yearOverflows() {
      let output = {}
      output.power = this.filtered(this.data.powerOverflow, 'YYYY')
      output.gas = this.filtered(this.data.gasOverlimit, 'YYYY')
      return output
    },
    day() {
      return {
        yesterday: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
        today: this.$moment().format('YYYY-MM-DD'),
        month: [
          this.$moment().startOf('month').format('YYYY-MM-DD'),
          this.$moment().endOf('month').format('YYYY-MM-DD'),
        ],
        year: [
          this.$moment().startOf('year').format('YYYY-MM-DD'),
          this.$moment().endOf('year').format('YYYY-MM-DD'),
        ],
      }
    },
  },
  watch: {
    filter: {
      deep: true,
      handler(item) {
        if (
          item.created_at.ge == this.day.today &&
          item.created_at.lt == this.day.today
        ) {
          this.activeFilter = 'todayDownloads'
        } else if (
          item.overflows == 3 &&
          item.date.ge == this.day.yesterday &&
          item.date.lt == this.day.yesterday
        ) {
          this.activeFilter = 'overflowsYesterday'
        } else if (
          item.overflows == 3 &&
          item.date.ge == this.day.month[0] &&
          item.date.lt == this.day.month[1]
        ) {
          this.activeFilter = 'overflowsThisMonth'
        } else if (
          item.overflows == 3 &&
          item.date.ge == this.day.year[0] &&
          item.date.lt == this.day.year[1]
        ) {
          this.activeFilter = 'overflowsThisYear'
        } else {
          this.activeFilter = null
        }
      },
    },
  },
  created() {
    this.getStats()
  },
  methods: {
    yesterday(data, format) {
      return data.filter(
        (item) =>
          this.$moment(item.date).format(format) ===
          this.$moment().subtract(1, 'days').format(format),
      ).length
    },
    filtered(data, format) {
      return data.filter(
        (item) =>
          this.$moment(item.date).format(format) ===
          this.$moment().format(format),
      ).length
    },
    getStats() {
      this.$api.get('energy_data/get_stats').then((res) => {
        this.data = res.data
        this.chartUpdate()
      })
    },
    chartUpdate() {
      this.yearOverflowsChart.options.labels = Object.keys(
        this.powerOverflows,
      ).map((item) => this.$moment(item).add(1, 'days').valueOf())
      this.yearOverflowsChart.series[0].data = Object.values(
        this.powerOverflows,
      )

      let gasOverflows = {}
      for (let i in { ...this.powerOverflows, ...this.gasOverflows }) {
        gasOverflows[i] = this.gasOverflows[i] ? this.gasOverflows[i] : null
      }
      this.yearOverflowsChart.series[1].data = Object.values(gasOverflows)
    },
    applyFilter(type) {
      const orig = { ...this.defaultFilter }
      delete orig.type
      Object.assign(this.filter, orig)
      this.$nextTick(() => {
        switch (type) {
          case 'todayDownloads':
            this.filter.created_at = { ge: this.day.today, lt: this.day.today }
            break
          case 'overflowsYesterday':
            this.filter.overflows = 3
            this.filter.date = {
              ge: this.day.yesterday,
              lt: this.day.yesterday,
            }
            break
          case 'overflowsThisMonth':
            this.filter.overflows = 3
            this.filter.date = {
              ge: this.day.month[0],
              lt: this.day.month[1],
            }
            break
          case 'overflowsThisYear':
            this.filter.overflows = 3
            this.filter.date = {
              ge: this.day.year[0],
              lt: this.day.year[1],
            }
            break
        }
        this.$emit('filter', type)
      })
    },
  },
}
</script>
